import './SearchResult.css';
import React, { Component } from 'react';
import SearchResultTable from './SearchResultTable';
import { withRouter } from 'react-router-dom';
import { Translate } from 'react-localize-redux';

class SearchResult extends Component {
  constructor(props) {
    super(props);

    this.loginAndSendRequest = this.loginAndSendRequest.bind(this);
    this.executePricingRequest = this.executePricingRequest.bind(this);
    this.onProductsSelection = this.onProductsSelection.bind(this);
  }

  loginAndSendRequest(e) {
    e.preventDefault();
    window.parent.location.href =
      process.env.REACT_APP_BACKEND_BASE_URL + '/redirect/login';
  }

  executePricingRequest() {
    this.props.history.push('/pricingRequest');
  }

  onProductsSelection(selection) {
    this.props.onProductsSelection(selection);
  }

  render() {
    const { data } = this.props;

    return (
      <div>
        {data && data.categories ? (
          <div>
            <h3 className="text-brand">
              <Translate id="SearchResult_SearchResult" />
            </h3>
            {data.categories
              .sort((a, b) => a.categoryName.localeCompare(b.categoryName))
              .map(d => (
                <SearchResultTable
                  key={d.key}
                  data={d}
                  onProductsSelection={this.onProductsSelection}
                />
              ))}

            {this.props.customerType === 'B2C' ? (
              <span />
            ) : (
              <div className="col-12 col-sm-12" style={{ textAlign: 'center' }}>
                {this.props.customerType === 'ANON' ? (
                  <button
                    className="btn btn-sm button-brand"
                    onClick={this.loginAndSendRequest}
                    disabled={!this.props.hasSelectedProducts}
                  >
                    <span>
                      <Translate id="SearchResult_LoginSendPriceRequest" />
                    </span>
                  </button>
                ) : (
                  <button
                    className="btn btn-sm button-brand"
                    onClick={this.executePricingRequest}
                    disabled={!this.props.hasSelectedProducts}
                  >
                    <span>
                      <Translate id="SearchResult_SendPriceRequest" />
                    </span>
                  </button>
                )}
              </div>
            )}
          </div>
        ) : (
          <span />
        )}
      </div>
    );
  }
}

export default withRouter(SearchResult);



// WEBPACK FOOTER //
// ./src/components/SearchResult.js